/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-10 16:44:43
 **/

import { PropsWithChildren } from "react";

import useWindowSize from "@/frameworks/core/hooks/useWindowSize/useWindowSize";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#WidgetItem#";

type WidgetItem = {
	index: number;
	data: WidgetSystem.Widget;
	center?: boolean;
};

export default function WidgetItem({ data }: PropsWithChildren<WidgetItem>) {
	const { width } = useWindowSize();
	if (data.type === "static") {
		const isCentered = data.center && width < 780;
		return (
			<div
				css={{
					position: "absolute",
					...(isCentered
						? {
								left: "50%",
								transform: "translateX(-50%)",
								top: `${data.location?.y || 0}px`
							}
						: {
								...((data.location?.x || 0) < 0
									? { right: `${Math.abs(data.location?.x || 0)}px` }
									: { left: `${data.location?.x || 0}px` }),
								...((data.location?.y || 0) < 0
									? { bottom: `${Math.abs(data.location?.y || 0)}px` }
									: { top: `${data.location?.y || 0}px` })
							})
				}}
			>
				{data.contents}
			</div>
		);
	}

	return <>{data.id}</>;
}
